import apiClient from 'utilities/apiClient';

// get_profilesdata
export const get_profilesdata = (payload) => {
  return apiClient.get(`${apiClient.Urls.profiletypes}`, payload);
};
